// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"8556ec53","627":"4232972a","787":"7a2669f8","936":"aeb92e90"}[chunkId] + ".chunk.js";
};